import { useQuery } from '@apollo/client';
import type { SafetyAction } from '@communities/content-management/domain';
import { GET_COMMUNITY_GROUP_ACTIONS } from '@communities/content-management/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityGroupActionsResponse {
  communityGroup: {
    id: string;
    actions: SafetyAction[];
  } | null;
}

export function useCommunityGroupActions(communityGroupId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityGroupActionsResponse>(GET_COMMUNITY_GROUP_ACTIONS, {
    variables: { communityGroupId },
    fetchPolicy: 'cache-first',
    skip: !communityGroupId,
  });

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  const actions: SafetyAction[] = data?.communityGroup?.actions || [];

  return {
    actions,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityGroupActions;
